import React, { useState } from "react";
import { MdCollections, MdSchool, MdBrush } from "react-icons/md";
import { konten, profil, tampilan } from "../../../routes";
import Links from "./Links";
import { media } from "../../../routes";
import { pengaturan } from "../../../routes";

function Menu() {
  const [showMediaDropdown, setShowMediaDropdown] = useState(false);
  const [showProfilDropdown, setShowProfilDropdown] = useState(false);

  const handleMediaClick = () => {
    setShowMediaDropdown(!showMediaDropdown);
  };

  const handleProfilClick = () => {
    setShowProfilDropdown(!showProfilDropdown);
  };

  return (
    <>
      <span className="flex items-center py-3 pl-8 text-base font-medium text-gray-500">
        Konten
      </span>
      <Links routes={konten} />

      <li
        className="flex cursor-pointer items-center py-3 pl-8 text-base font-medium text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-white/10"
        onClick={handleProfilClick}
      >
        <MdSchool className="mr-4 h-6 w-6" />
        Profil
        <svg
          className={`ml-auto h-6 w-6 transition-transform duration-200 ${showProfilDropdown ? "rotate-180" : ""}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </li>
      {showProfilDropdown && (
        <div className="pl-8">
          <Links routes={profil} />
        </div>
      )}

      <li
        className="flex cursor-pointer items-center py-3 pl-8 text-base font-medium text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-white/10"
        onClick={handleMediaClick}
      >
        <MdCollections className="mr-4 h-6 w-6" />
        Media
        <svg
          className={`ml-auto h-6 w-6 transition-transform duration-200 ${showMediaDropdown ? "rotate-180" : ""}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </li>
      {showMediaDropdown && (
        <div className="pl-8">
          <Links routes={media} />
        </div>
      )}

      <span className="flex items-center py-3 pl-8 text-base font-medium text-gray-500">
        Tampilan
      </span>
      <Links routes={tampilan} />

      <span className="flex items-center py-3 pl-8 text-base font-medium text-gray-500">
        Pengaturan
      </span>
      <Links routes={pengaturan} />
    </>
  );
}

export default Menu;
